import { toDisplayString } from 'vue'
import type { StandardDetail } from '@/standards/standard_types'

export function fieldText(standard: Partial<StandardDetail>, field: string): string {
  return toDisplayString(standard[field])
}

export function hasField(standard: Partial<StandardDetail>, field: string): boolean {
  return Boolean(standard[field])
}
